import s from './Reestrs.module.css';

const Reestrs = () => <div className={s.containerCabinet}>Reestrs</div>
      
export default Reestrs;
